import { Action } from '@ngrx/store';

import { ProductFilters } from '@app-model/filters/product-filters';
import { Markup } from '@app-model/login';
import { GetProductsRequest } from '@app-model/request';
import { GetProductsResponse, ProductItem } from '@app-model/response';

// ACTION TYPES
export const GET_PRODUCTS = '[PRODUCT] GET PRODUCTS';
export const GET_PRODUCTS_SUCCESS = '[PRODUCT] GET PRODUCTS SUCCESS';
export const GET_PRODUCTS_FAILURE = '[PRODUCT] Get PRODUCTS FAILURE';
export const FILTER_GRID = '[PRODUCT] FILTER GRID'; //deprecated
export const FILTER_GRID_SUCCESS = '[PRODUCT] FILTER GRID SUCCESS'; // deprecated
export const SORT_GRID = '[PRODUCT] SORT GRID';
export const RESET_PRODUCTS = '[PRODUCT] RESET PRODUCTS';
export const LOAD_PRODUCT_QUOTE = '[PRODUCT] LOAD PRODUCT QUOTE';
export const ADD_MARKUP_TO_COST = '[PRODUCT] ADD MARKUP TO COST';
export const CHANGE_MARKUP = '[PRODUCT] CHANGE MARKUP';
export const FILTER_BUNDLE = '[PRODUCT] FILTER BUNDLE';
export const APPLY_FILTERS = '[PRODUCT] APPLY FILTERS';

export class GetProducts implements Action {
  readonly type = GET_PRODUCTS;

  constructor(public payload: GetProductsRequest) {}
}

export class ChangeMarkupAction implements Action {
  readonly type = CHANGE_MARKUP;

  constructor(public payload: { markup: Markup }) {}
}

export class AddMarkupToCostAction implements Action {
  readonly type = ADD_MARKUP_TO_COST;

  constructor(public payload: { markup: Markup; grid: ProductItem[] }) {}
}

export class GetProductsSuccess implements Action {
  readonly type = GET_PRODUCTS_SUCCESS;

  constructor(
    public response: GetProductsResponse,
    public markup: Markup
  ) {}
}

export class GetProductsFailure implements Action {
  readonly type = GET_PRODUCTS_FAILURE;

  constructor(public payload: { error: string }) {}
}

export class FilterGridAction implements Action {
  readonly type = FILTER_GRID;

  constructor(public payload: ProductFilters) {}
}

export class FilterGridSuccessAction implements Action {
  readonly type = FILTER_GRID_SUCCESS;

  constructor(public payload: { filters: ProductFilters; grid: ProductItem[] }) {}
}

export class FilterBundleAction implements Action {
  readonly type = FILTER_BUNDLE;

  constructor(public payload: ProductFilters) {}
}

export class SortGridAction implements Action {
  readonly type = SORT_GRID;

  constructor(public payload: ProductItem[]) {}
}

export class LoadProductQuoteAction implements Action {
  readonly type = LOAD_PRODUCT_QUOTE;

  constructor(
    public payload: {
      request: GetProductsRequest;
      response: GetProductsResponse;
      gridProducts: ProductItem[];
      filters: ProductFilters;
      markup: Markup;
    }
  ) {}
}

export class ResetProductsAction implements Action {
  readonly type = RESET_PRODUCTS;
}

export class ApplyFilters implements Action {
  readonly type = APPLY_FILTERS;
  constructor(public filters: ProductFilters) {}
}

export type All =
  | GetProducts
  | GetProductsSuccess
  | GetProductsFailure
  | ResetProductsAction
  | FilterGridSuccessAction
  | SortGridAction
  | LoadProductQuoteAction
  | AddMarkupToCostAction
  | ChangeMarkupAction
  | ApplyFilters;
